module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event/event_photo-bbf2b91dbb44ac9adbf482f4efb54cf1.jpg";